/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';
import { DegreeIcon } from '@coursera/cds-icons';

const MAX_WIDTH_PILL = '252px';

type TermBadgeProps = {
  termName: string | null;
};

const styles = {
  termBadge: css`
    display: inline-flex;
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: var(--cds-spacing-150);
    border-radius: 50px;
    border: var(--cds-spacing-100) solid var(--cds-color-emphasis-tertiary-background-default);
    background: var(--cds-color-neutral-background-primary);
    max-width: ${MAX_WIDTH_PILL};
  `,

  termBadgeIcon: css`
    /* to override cds default */
    overflow: visible !important;
  `,
};

const TermBadge: React.FC<TermBadgeProps> = ({ termName }) => {
  if (!termName) {
    return null;
  }
  return (
    <div css={styles.termBadge}>
      <DegreeIcon css={styles.termBadgeIcon} size="large" />
      <Typography variant="h2semibold">{termName}</Typography>
    </div>
  );
};

export default TermBadge;
